




import { CoreComponent } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from 'vuex';

@Component({
    components: {
        EmpathyX: CoreComponent
    },
    computed: {
        ...mapGetters({ isBlog: 'search/isBlog'})
    }
})
export default class App extends Vue {
  mounted() {
    const close = document.createElement('div');
    close.setAttribute('class', 'ebx-header-close');
    close.setAttribute('style', 'display:none;');
    const desktopHeader = document.querySelector('.top-links');
    const mobileHeader = document.querySelector('.show-bg');
    if (desktopHeader) {
      desktopHeader.appendChild(close);
    } else if (mobileHeader) {
      mobileHeader.appendChild(close);
    }
  }
}
